<template>
  <fieldset class="mode-cards">
    <legend class="sr-only">{{ legend }}</legend>
    <label
      v-for="opt in options"
      :key="opt.value"
      class="mode-card"
      :class="{ 'is-selected': value === opt.value, 'is-disabled': opt.disabled }"
    >
      <b-form-radio
        :checked="value"
        :value="opt.value"
        :name="name"
        :disabled="opt.disabled"
        @change="$emit('input', opt.value)"
      >
        <span class="mode-card__title">{{ opt.title || opt.text }}</span>
        <span v-if="opt.sub" class="mode-card__sub">{{ opt.sub }}</span>
      </b-form-radio>
    </label>
  </fieldset>
</template>

<script>
// Radio choices laid out as cards, so every option is visible without opening a dropdown.
export default {
  name: 'ModeCards',
  props: {
    value: { type: String, default: null },
    // [{ value, text, title?, sub?, disabled? }]; title overrides text on the card
    options: { type: Array, required: true },
    name: { type: String, required: true },
    legend: { type: String, required: true },
  },
  emits: ['input'],
};
</script>

<style scoped lang="scss">
.mode-cards {
  display: grid;
  gap: 0.75rem;
  grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));
  margin: 0;
}

.mode-card {
  align-items: flex-start;
  background: var(--palette-color-base-white);
  border: 1px solid var(--palette-color-default-lighten-80);
  border-radius: 1rem;
  cursor: pointer;
  display: flex;
  margin: 0;
  padding: 1rem 1.25rem;

  &.is-selected {
    border-color: var(--palette-color-brand-primary);
    box-shadow: 0 0 0 1px var(--palette-color-brand-primary);
  }

  &.is-disabled {
    cursor: not-allowed;
  }
}

.mode-card__title {
  color: var(--palette-color-default);
  display: block;
  font-weight: 600;
}

.mode-card__sub {
  color: var(--palette-color-default-lighten-20);
  display: block;
  font-size: 0.8125rem;
}
</style>
